import React, { createContext, useContext, useEffect, useState } from 'react';

type BrandCtx = {
  brandId: number | string | null;
  setBrandId: (id: number | string | null) => void;
};

const Ctx = createContext<BrandCtx | undefined>(undefined);

export const BrandProvider: React.FC = ({ children }) => {
  const readInitial = (): number | string | null => {
    const raw = localStorage.getItem('brandId');
    const n = raw != null ? Number(raw) : NaN;
    return Number.isFinite(n) ? n : null;
  };

  const [brandId, setBrandIdState] = useState<number | string | null>(
    readInitial()
  );

  const setBrandId = (id: number | string | null) => {
    if (id == null) localStorage.removeItem('brandId');
    else localStorage.setItem('brandId', String(id));
    setBrandIdState(id);
  };

  useEffect(() => {
    const onStorage = (e: StorageEvent) => {
      if (e.key === 'brandId') {
        const next = e.newValue !== null ? Number(e.newValue) : null;
        setBrandIdState(next !== null && Number.isFinite(next) ? next : null);
      }
    };
    window.addEventListener('storage', onStorage);
    return () => window.removeEventListener('storage', onStorage);
  }, []);

  return (
    <Ctx.Provider value={{ brandId, setBrandId }}>{children}</Ctx.Provider>
  );
};

export const useBrand = (): BrandCtx => {
  const ctx = useContext(Ctx);
  if (!ctx) throw new Error('useBrand must be used within <BrandProvider>');
  return ctx;
};
